import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, Link, useSearchParams } from "react-router-dom";
const { REACT_APP_GOOGLE_CLIENT_ID } = process.env;

export const RegisterPage = (props) => {
  const { userRegister, isLoggedIn, isLoading, userGoogleRegister } = props;
  const [searchParams] = useSearchParams();
  const redirection = searchParams.get("redirect_path");
  const [showPassword, setShowPassword] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if(isLoggedIn) {
      if(redirection) {
        navigate(`/${redirection}`);
      } else {
        navigate("/");
      }
    }
  }, [isLoggedIn]);

  // useEffect(() => {
  //   if(window.google) {
  //     window.google.accounts.id.initialize({
  //       client_id: REACT_APP_GOOGLE_CLIENT_ID,
  //       callback: handleCallbackResponse
  //     });
  
  //     window.google.accounts.id.renderButton(document.getElementById('signInDiv'), {
  //       theme: 'outline',
  //       size: 'large'
  //     })
  //     window.google.accounts.id.prompt()
  //   }
  // }, []);

  // let handleCallbackResponse = (response) => {
  //   userGoogleRegister(response.credential);
  // }

  const onSubmit = (data) => {
    userRegister(data);
  };

  return (
     <>
        <div className="full-row bg-light overlay-dark py-5"
          style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
          <div className="container">
            <div className="row text-center text-white">
              <div className="col-12">
                <h3 className="mb-2 text-white font-weight-bold">Register Page</h3>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center bg-transparent">
                    <li className="breadcrumb-item">
                      <a href="#" className="text-white">Home</a>
                    </li>
                    <li className="breadcrumb-item active text-white" aria-current="page">Register</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="container d-flex justify-content-center align-items-center py-5">
          <div className="card p-4" style={{width: "100%", maxWidth: "600px"}}>
            <h4 className="mb-4" style={{fontWeight: 700, fontSize: "30px"}}>User register</h4>
            <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label for="firstName" className="form-label text-secondary">First name<span className="text-danger">*</span></label>
                <input type="text" name="firstName" {...register('firstName', { required: 'First name is required' })} className="form-control" id="firstName" placeholder="Type First name"/>
                {errors.firstName && <p className="text-danger px-2">{errors.firstName.message}</p>}
              </div>
              <div className="mb-3">
                <label for="lastName" className="form-label text-secondary">Last name<span className="text-danger">*</span></label>
                <input type="text" name="lastName" {...register('lastName', { required: 'Last name is required' })} className="form-control" id="lastName" placeholder="Type Last name"/>
                {errors.lastName && <p className="text-danger px-2">{errors.lastName.message}</p>}
              </div>
              <div className="mb-3">
                <label for="phone" className="form-label text-secondary">Phone number<span className="text-danger">*</span></label>
                <input type="text" name="phone" {...register('phone', { required: 'Phone number is required' })} className="form-control" id="phone" placeholder="Type Phone number"/>
                {errors.phone && <p className="text-danger px-2">{errors.phone.message}</p>}
              </div>
              <div className="mb-3">
                <label for="email" className="form-label text-secondary">Email address<span className="text-danger">*</span></label>
                <input type="text" name="email" {...register('email', { required: 'Email address is required' })} className="form-control" id="email" placeholder="Type Email Address"/>
                {errors.email && <p className="text-danger px-2">{errors.email.message}</p>}
              </div>
              <div className="mb-3">
                <label for="password" className="form-label text-secondary">Password<span className="text-danger">*</span></label>
                <input name="password" type="password" {...register('password', { required: 'Password is required' })}className="form-control" id="password" placeholder="Type Password"/>
                {errors.password && <div className="text-danger px-2">{errors.password.message}</div>}
              </div>
              <div className="d-flex justify-content-between mb-3">
                <Link to={redirection ? `/login?redirect_path=${redirection}` : "/login"} className="text-decoration-none text-dark">Already have any account?</Link>
                <Link to="/forget-password" className="text-decoration-none text-dark">Lost your password?</Link>
              </div>

              <button type="submit" className="btn w-100"
                style={{backgroundColor: "#424A4D", borderRadius: 0, color: "white", height: "40px"}}>Register</button>
            </form>
            {/* <div className="text-center mt-4" style={{display: "flex", justifyContent: "center", flexDirection: "column"}}>
              <p className="mb-2" style={{fontWeight: 700, fontSize: "30px"}}>OR</p>
              <div id="signInDiv"></div>
            </div> */}
          </div>
        </div>
      </>
  );
};
